<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <RouterLink
        :class="'h-full flex items-center justify-center comp-bg-' + COMPANY_SHORT"
        style="width: 35vw"
        to="/"
        aria-label="Visit homepage"
      >
        <p class="font-bold mr-3">DATAHUB by</p>
        <DatahubLogo :height="36" start="#FFF" />
      </RouterLink>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else :class="'h-screen comp-bg-' + COMPANY_SHORT">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-start">
            DATAHUB by
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <DatahubLogo :height="26" class="mb-2" start="#0E41C9" />
            </RouterLink>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useBreakpoint } from 'vuestic-ui'
import DatahubLogo from '../components/DatahubLogo.vue'
const getCompByDom = () => {
  const domparts = location.hostname.split('.')
  if (domparts.length == 4) return domparts[0].replace(/[^a-z]/, '').toUpperCase()
  return 'WPE'
}
const COMPANY_SHORT = ref(import.meta.env.DEV ? import.meta.env.VITE_APP_COMPANY_SHORT : getCompByDom())
const breakpoint = useBreakpoint()
</script>
